<template>
  <div class="mb-24">
    <fieldset>
      <legend class="form__label pb-8">Add the gender marker on your government ID</legend>
      <HelperText
        text="This answer is used for Trust and Safety screening purposes and will not be visible on your profile."
        custom-classes="-ml-4"
      />
      <div class="inline-flex">
        <poppins-radio-button
          id="m-gender"
          v-model="form.gender"
          radio-name="gender"
          label-name="M"
          radio-value="male"
          class="mr-32 my-16"
        />
        <poppins-radio-button
          id="f-gender"
          v-model="form.gender"
          label-name="F"
          radio-name="gender"
          radio-value="female"
          class="mr-32 my-16"
        />
        <poppins-radio-button
          id="x-gender"
          v-model="form.gender"
          label-name="X"
          radio-name="gender"
          radio-value="x"
          class="mr-32 my-16"
          @blur="validateGender"
        />
      </div>
      <HelperText v-if="hasErrors" :status="0" custom-classes="-mt-8 flex relative" :text="helperText(formStatuses.gender)" />
    </fieldset>
  </div>
</template>

<script lang="ts">
import helperStatus from '@/helpers/status';
import RadioButton from '@/components/radio_button/RadioButton.vue';
import HelperText from '@/components/helper_text/HelperText.vue';

export default {
  name: 'GenderRadio',
  components: {
    PoppinsRadioButton: RadioButton,
    HelperText,
  },
  emits: ['input'],
  data(): any {
    return {
      form: {
        gender: undefined,
      },
      formStatuses: {
        gender: helperStatus.Neutral,
      },
    };
  },
  computed: {
    fieldIsValid(): boolean {
      return typeof this.form.gender !== 'undefined';
    },
    hasErrors(): boolean {
      return this.formStatuses.gender === helperStatus.Error;
    },
  },
  watch: {
    'form.gender': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onInput();
        this.formStatuses.gender = helperStatus.Neutral;
      }
    },
  },
  methods: {
    onInput() {
      this.$emit('input', 'gender', this.form.gender);
    },
    validateGender() {
      if (!this.fieldIsValid) {
        this.formStatuses.gender = helperStatus.Error;
      }
      return this.formStatuses.gender;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Error) {
        return 'Select one of the options above';
      }
      return '';
    },
  },
};
</script>
